import showMessage from './messages';


class StateToggleSwitch {
  constructor ({$indicator, $switch, url = null, onOffText = null}) {
    if (url === null) url = templateData('stateUrl');
    if (onOffText === null) onOffText = ['Active', 'Suspended'];

    this.url = url;
    [this.onText, this.offText] = onOffText;
    this.$indicator = $indicator;
    this.$switch = $switch;
    this.setEventListeners();
  }

  toggleIndicator (isActive) {
    this.$indicator.removeClass('badge-warning');
    if (isActive) {
      this.$indicator.removeClass('badge-danger').addClass('badge-success');
      this.$indicator.text(this.onText);
      this.$switch.addClass('active');
    } else {
      this.$indicator.removeClass('badge-success').addClass('badge-danger');
      this.$indicator.text(this.offText);
      this.$switch.removeClass('active');
    }
  }

  setEventListeners () {
    this.$switch.click(() => {
      this.$switch.prop('disabled', true).toggleClass('active');
      this.$indicator.removeClass('badge-success badge-danger').addClass('badge-warning');
      this.$indicator.text('Updating...');

      $.ajax({
        url: this.url,
        data: {csrfmiddlewaretoken: templateData('csrfToken')},
        method: 'POST',
        success: ({isActive}) => {
          this.toggleIndicator(isActive);
          setTimeout(() => {
            this.$switch.prop('disabled', false);
          }, 5000);
        },
        error: ({status, responseJSON}) => {
          this.$indicator.removeClass('badge-success').addClass('badge-danger');
          let errorMessage = (
            `There was an error whilst trying to change the status.
             Please refresh your page, or try again later.`
          );
          if (status === 403) {
            errorMessage = responseJSON.error;
          }
          showMessage(errorMessage, 'danger');
          this.$indicator.text('Error');
          this.$switch.toggleClass('active');
        },
      });
    });
  }
}

export default StateToggleSwitch;
